import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Usef_horse } from '../models/usef/usef_horse';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class UsefHorseSearchService {

  constructor(private http: HttpClient) { }

getById(search_id_term: string ): Promise<Usef_horse[]> {
	return this.getListWithRest("horse_id/" + search_id_term);
}


getByName(search_name_term: string ): Promise<Usef_horse[]> {
	return this.getListWithRest("horse_name/" + search_name_term);
}

private getListWithRest(rest_url: string) : Promise<Usef_horse[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'usef_search/' + rest_url).subscribe((response:any) => {
			if(response.type == 'usef_horses' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }



}


